import { useEffect } from 'react';
import OtpInput from 'react-otp-input';
import CountDown from '../countDown/countDown';
import { IOtpInput } from './IOtpInput';
import './otpInput.css';

export default function CustomisedOtpInputAutoFill({
    otp,
    setOtp,
    numInputs,
    otpTime,
    resendOtp,
    error
}: IOtpInput) {

    useEffect(() => {
        interface OTPRequestOptions extends CredentialRequestOptions {
            otp?: {
                transport: string[];
            };
        }

        async function fetchOTP() {
            if ('OTPCredential' in window) {
                try {
                    const ac = new AbortController();
                    const otp: any = await navigator.credentials.get({
                        otp: { transport: ['sms'] },
                        signal: ac.signal,
                    } as OTPRequestOptions);
                    // alert(`OTP received and set: ${otp}`)
                    // const expectedMessagePattern = /Your OTP code is (\d{6})/;
                    if (otp && otp.code) {
                        // const match = expectedMessagePattern.exec(otp.code);
                        setOtp(otp.code);
                        // alert(`OTP received and set: ${otp.code}`)
                    }
                } catch (err) {
                    // alert(`Error retrieving OTP:', ${err}`)
                }
            } else {
                console.warn(
                    'OTPCredential API is not supported in this browser.'
                );
                // alert('OTPCredential API is not supported in this browser.')
            }
        }


        fetchOTP();
    }, []);

    return (
        <div>
            <div dir="ltr" style={{ display: 'flex', justifyContent: 'center' }}>
                <OtpInput
                    errorStyle={{ border: '1px solid #FF617C', color: '#FF617C' }}
                    isInputNum={true}
                    value={otp}
                    onChange={setOtp}
                    numInputs={numInputs}
                    separator={<span></span>}
                    shouldAutoFocus
                    className="otpInput "
                    inputStyle={{
                        width: '2.2em',
                        height: '2.1em',
                        fontSize: '24px',
                        border: `1px solid ${error ? '#FF617C' : 'var(--header-border-color)'} `,
                        outline: 'none',
                        borderRadius: '6px',
                        name: 'otp',
                        id: 'otp',
                        margin: '0px 5px',
                        backgroundColor: `rgba(0, 0, 0, 0.08)`,
                        color: 'var(--primary-text-color)',

                    }}
                />

            </div>
            <div style={{ marginTop: '30px', textAlign: 'center' }}>
                {otpTime && (
                    <CountDown countDownValue={otpTime} resendOtp={resendOtp} />
                )}
            </div>
        </div>
    );
}
